import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ICorretor } from '../../shared/types/ICorretor';
import { IVerificaEmailPayload } from './../types/IVerificaEmailPayload';
import { IVerificaCadastroPayload } from '../types/IVerificaCadastroPayload';
import { IGetVideosResponse } from '../types/IGetVideosResponse';

@Injectable({
  providedIn: 'root'
})
export class CorretorService {
  private host: string = environment.api.host;
  private methods = environment.api.endpoints.methods.corretor;

  constructor(
    private http: HttpClient, 
  ) { }

  getCorretorLogado(): Observable<ICorretor> {
    const url = this.host + this.methods.get.info;

    return this.http.get<ICorretor>(url);
  }

  verificarSeCpfJaTemCadastro(payload: IVerificaCadastroPayload): Observable<any> {    
    const url = this.host + this.methods.get.verificaCadastro;

    return this.http.post<IVerificaCadastroPayload>(url, payload);
  }

  verificarSeEmailJaTemCadastro(payload: IVerificaEmailPayload): Observable<any> {
    const url = this.host + this.methods.get.verificaEmail;

    return this.http.post(url, payload);
  }

  verificarSeEmailJaTemCadastroSemToken(email: string): Observable<any> {
    const url = this.host + this.methods.get.verificaEmail;

    return this.http.get(url, { params: { email }});
  }

  getVideos(): Observable<IGetVideosResponse[]> {
    const url = this.host + this.methods.get.videos;

    return this.http.get<IGetVideosResponse[]>(url);
  }

  getVideoByUid(uid: string) {
    const url = this.host + this.methods.get.videoByUid;

    return this.http.get<IGetVideosResponse[]>(url, { params: { uid }});
  }
}
